export default __webpack_public_path__ + "static/26_01_2021-5386362af54d1badc1acf81f7518a3e1.png";